import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';

// Global styles
//import './styles/main.css';
// import './styles/footer.css'; // Uncomment if needed

// Context
import { AuthProvider } from './context/AuthContext';

// ✅ Create root BEFORE using it
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
     <BrowserRouter>
    <AuthProvider>
        <App />
    </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
